export const SliderData = [
  {
    title: "Work Faster with a Smart Editor",
    image: "pic1.webp",
    description_part1:
      "Produce high-quality code more efficiently, thanks to first-class support for Ruby and Rails, JavaScript and CoffeeScript, ERB and HAML, CSS, Sass and Less, and more.",
    description_part2:
      "Take advantage of the language specific-aware syntax & error highlighting, code formatting, code completion, and quick documentation.",
  },
  {
    title: "Find Your Way Around",
    image: "pic2.webp",
    description_part1:
      "Use smart search to jump to any class, file or symbol, or even any IDE action or tool window. It only takes one click to switch to the declaration, super method, test, usages, implementation, and more.",
    description_part2:
      "Enjoy super fast navigation in your Rails project with an MVC-based project view and model, class, and gem dependencies diagrams.",
  },
  {
    title: "Detect & Eliminate Code Smells",
    image: "pic3.webp",
    description_part1:
      "Follow community best practices with code inspections verifying your code for many types of possible errors and providing on-the-fly improvements with quick-fix options.",
    description_part2:
      "Automated yet safe refactorings help clean up your code and keep it more maintainable. Rails-aware refactorings help you perform project-wide changes: for example renaming a controller will also rename the helper, views, and tests.",
  },
  {
    title: "Test & Debug with Pleasure",
    image: "pic4.webp",
    description_part1:
      "Use the powerful debugger with a graphical UI for Ruby, JavaScript, and CoffeeScript. Set breakpoints, run your code step by step and make use of all the available information at your fingertips.",
    description_part2:
      "Create and run RSpec, Cucumber, Shoulda, MiniTest & Test::Unit tests with coding assistance and a GUI-based test runner.",
  },
  {
    title: "Enjoy a Fine‐Tuned Workspace",
    image: "pic5.webp",
    description_part1:
      "In RubyMine you can quickly help yourself feel at home, with customizable color schemes, keyboard schemes, and all the look-and-feel settings you need for productive development.",
    description_part2:
      "Save time with a unified UI for working with Git, SVN, Mercurial and other version control systems.",
  },
  {
    title: "Manage Your Project Environment",
    image: "pic6.webp",
    description_part1:
      "Enjoy seamless integration with tools like Rake Task Runner, Rails Generators, Bundler, RVM/Rbenv, Zeus, and others. The Terminal is also available as an IDE tool window whenever you need it.",
    description_part2:
      "Easily configure automatic deployment via FTP or SFTP and manage your infrastructure with Vagrant, Capistrano, Chef, or Puppet.",
  },
];
